import React, { useEffect, useState } from "react";
import styles from "./EmployeeProfile.module.css";
import { FiArrowLeft } from "react-icons/fi";
import { Employee } from "../Models/Models";
import WebService from "../Services/WebService";
import { mediaUrl } from "../Services/mediaUrl";
import { useNavigate } from "react-router-dom";

interface RoleObj {
  role_id: number;
  role_name: string;
}

interface EmployeeProfileProps {
  open: boolean;
  employeeId: number | null;
  onClose: () => void;
}

const displayValue = (val: any): string =>
  val !== undefined && val !== null && val !== "" ? String(val) : "Not Provided";

const EmployeeProfile: React.FC<EmployeeProfileProps> = ({ open, employeeId, onClose }) => {
  const [employee, setEmployee] = useState<Employee | null>(null);
  const [roles, setRoles] = useState<RoleObj[]>([]);
  const [, setUserStatus] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!open || !employeeId) return;

    WebService.getAPI<{ data: { employees: Employee[] } }>({
      action: `/v1/door-management/employees?employee_id=${employeeId}`,
    })
      .then((res) => {
        const emp = res?.data?.employees?.[0] || null;
        setEmployee(emp);
        setUserStatus(emp?.user_status ?? "");
      })
      .catch(() => setEmployee(null));
  }, [open, employeeId]);

  useEffect(() => {
    if (!open) return;
    WebService.getAPI<{ data: RoleObj[] }>({
      action: "/v1/door-management/rbac/roles",
      type: "",
    })
      .then((res) => setRoles(res.data || []))
      .catch(() => setRoles([]));
  }, [open]);

  const roleName =
    roles.find((r) => r.role_id === employee?.role_id)?.role_name || "Not Provided";

  const aadhaarDoc = employee?.images?.find(img => img.doc_type === "aadhaar")?.file_name || null;
  const panDoc = employee?.images?.find(img => img.doc_type === "pan")?.file_name || null;
  const profileRaw = employee?.images?.find(img => img.doc_type === "profile")?.file_name;
  const profileImg = profileRaw ? mediaUrl(profileRaw) : "/Assets/employee.png";
  const aadhaarUrl = aadhaarDoc ? mediaUrl(aadhaarDoc) : null;
  const panUrl = panDoc ? mediaUrl(panDoc) : null;

  const handleViewTask = () => {
    if (employee?.user_id) {
      navigate(`/task-management/${employee.user_id}`);
    }
  };


  if (!open || !employee) return null;

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.panel} onClick={(e) => e.stopPropagation()}>
        <div className={styles.header}>
          <button className={styles.backBtn} onClick={onClose}>
            <FiArrowLeft size={22} />
          </button>
          <span className={styles.headerTitle}>Employee Profile</span>
        </div>

        <div className={styles.profileCard}>
          <div className={styles.topRow}>
            <img src={profileImg} alt="avatar" className={styles.avatar} />
            <div className={styles.basicInfo}>
              <div className={styles.topInfo}>
                <span className={styles.profileName}>{displayValue(employee.username)}</span>
              </div>
              <span className={styles.empId}>
                EmpID: {displayValue(employee.employee_id ?? employee.user_id)}
              </span>
            </div>
            <div className={styles.topActions}>
              {/* <span className={`${styles.status} ${userStatus === "ACTIVE" ? styles.active : styles.inactive}`}>{displayValue(userStatus)}</span> */}
              <button className={styles.assignBtn} onClick={handleViewTask}>View Task</button>
              {/* <select className={styles.statusSelect} value={userStatus} onChange={handleStatusChange} disabled={statusLoading}> */}
                {/* <option value="ACTIVE">ACTIVE</option>
                <option value="INACTIVE">INACTIVE</option>
              </select> */}
              {/* {statusLoading && <span style={{ marginLeft: 8, color: "#FFA500" }}>Updating...</span>} */}
            </div>
          </div>
        </div>

        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}><span>Basic Information</span></div>
          <div className={styles.infoGrid}>
            <div><label>Full Name</label><div>{displayValue(employee.username)}</div></div>
            <div><label>Email</label><div>{displayValue(employee.email)}</div></div>
            <div><label>Assigned Mobile Number</label><div>{displayValue(employee.mobile_number)}</div></div>
            <div><label>Employee ID</label><div>{displayValue(employee.employee_id ?? employee.user_id)}</div></div>
            <div style={{ gridColumn: "1 / span 2" }}><label>Address</label><div>{displayValue(employee.address?.[0]?.complete_address)}</div></div>
            <div><label>Date of Joining</label><div>{employee.joining_date ? new Date(employee.joining_date).toLocaleDateString() : "Not Provided"}</div></div>
          </div>
        </div>

        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}><span>Employment Details</span></div>
          <div className={styles.infoGrid}>
            <div><label>User Type</label><div>{displayValue(employee.user_type)}</div></div>
            <div><label>Role</label><div>{displayValue(roleName)}</div></div>
            <div><label>Account Number</label><div>{displayValue(employee.account_number)}</div></div>
            <div><label>PAN</label><div>{displayValue(employee.pan)}</div></div>
          </div>
        </div>

        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}><span>Leave Balance</span></div>
          <div className={styles.infoGrid}>
            <div><label>Casual Leave</label><div><span className={styles.plannedLeave}>{displayValue(employee.casual_leave_balance)}</span> days</div></div>
            <div><label>Sick Leave</label><div><span className={styles.sickLeave}>{displayValue(employee.sick_leave_balance)}</span> days</div></div>
          </div>
        </div>

        <div className={styles.sectionCard}>
          <div className={styles.sectionHeader}><span>Personal Documents</span></div>
          <div className={styles.docsRow}>
            <div className={styles.docCard}>
              <div>Aadhaar Card</div>
              {aadhaarUrl ? (
                <div className={styles.docPreview}>
                  {/\.pdf$/i.test(aadhaarDoc || "") ? (
                    <a href={aadhaarUrl} className={styles.downloadBtn} download target="_blank" rel="noopener noreferrer">View Aadhaar.pdf</a>
                  ) : (
                    <a href={aadhaarUrl} target="_blank" rel="noopener noreferrer">
                      <img src={aadhaarUrl} alt="Aadhaar" className={styles.docImage} />
                    </a>
                  )}
                  <div className={styles.docHint}>Uploaded recently</div>
                </div>
              ) : (
                <span className={`${styles.downloadBtn} ${styles.disabled}`}>Not Uploaded</span>
              )}
            </div>

            <div className={styles.docCard}>
              <div>PAN Card</div>
              {panUrl ? (
                <div className={styles.docPreview}>
                  {/\.pdf$/i.test(panDoc || "") ? (
                    <a href={panUrl} className={styles.downloadBtn} download target="_blank" rel="noopener noreferrer">View PAN.pdf</a>
                  ) : (
                    <a href={panUrl} target="_blank" rel="noopener noreferrer">
                      <img src={panUrl} alt="PAN" className={styles.docImage} />
                    </a>
                  )}
                  <div className={styles.docHint}>Uploaded recently</div>
                </div>
              ) : (
                <span className={`${styles.downloadBtn} ${styles.disabled}`}>Not Uploaded</span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeProfile;
